import React, { useState } from "react";
import AppText from "./AppText";
import { appStrings } from "./strings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import Button from "../../presentational/Button";
import PasswordTippy from "../../PasswordTippy";

import "./SetPassword.css";

interface SetPasswordProps {
    serverError: string;
    isLoading: boolean;
    isPasswordInit: boolean;
    email: string;
    validatePasswordRequirements: (password: string) => Promise<string>;
    updatePassword: (password: string) => void;
}

const SetPassword: React.FC<SetPasswordProps> = ({
    serverError,
    isLoading,
    isPasswordInit,
    email,
    validatePasswordRequirements,
    updatePassword,
}) => {
    const [unmaskPassword, setUnmaskPassword] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordValid, setPasswordValid] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        updatePassword(password);
    };

    const onSetPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event?.target?.value);
    };
    

    return (
        <main className="set-password-page">
            <div className="form-wrapper">
                <form className="form" onSubmit={handleSubmit}>
                    <div className="form-header">
                        <img
                            className="form-header-logo"
                            src="https://assets.careevolutionapps.com/CareEvolution/Images/MDHD/mdhd-blue-bug-logo-centered.svg"
                            alt="MyDataHelps Designer Logo"
                        />
                        <h2>
                            <AppText
                                textKey={
                                    isPasswordInit
                                        ? "initialize-password-title"
                                        : "reset-password-title"
                                }
                            />
                        </h2>
                    </div>
                    <p className="email-detail">
                        <AppText textKey="reset-password-info" values={{ email: email }} />
                    </p>
                    {serverError && <p className="server-error">{serverError}</p>}
                    <div className="field-group">
                        <label>{appStrings["password-label"]}</label>
                        <div className="combo-input-group">
                            <PasswordTippy
                                password={password}
                                passwordValid={passwordValid}
                                setPasswordValid={setPasswordValid}
                                validatePasswordRequirements={validatePasswordRequirements}
                                requirementsTitle={appStrings["password-requirements-title"]} 
                                requirementLengthText={appStrings["password-requirement-length"]} 
                                requirementClassesText={appStrings["password-requirement-classes"]}>
                              <input
                                autoComplete="new-password"
                                className="autofocus admin-input"
                                id="resetPassword"
                                type={unmaskPassword ? "text" : "password"}
                                value={password}
                                onChange={onSetPassword}
                                placeholder={appStrings["password-placeholder"]}
                                spellCheck={false}
                                autoCapitalize="none"
                                autoCorrect="off"
                                autoFocus={true}
                                maxLength={64}
                              />
                            </PasswordTippy>
                            <button
                                type="button"
                                onClick={() => setUnmaskPassword(!unmaskPassword)}
                                className="password-mask-toggle editor-controls-button"
                                title="Toggle password visibility"
                            >
                                <FontAwesomeIcon
                                    icon={unmaskPassword ? (faEye as IconProp) : (faEyeSlash as IconProp)}
                                />
                            </button>
                        </div>
                    </div>
                    <Button
                        intent="primary"
                        onClick={handleSubmit}
                        disabled={!passwordValid}
                        className="primary-button editor-controls-button"
                        loading={isLoading}
                        type="submit"
                    >
                        <AppText textKey="next-label" />
                    </Button>
                </form>
            </div>
        </main>
    );
};

export default SetPassword;
